export default "__VITE_ASSET__CGBXZ9Kl__"